module.exports = __webpack_public_path__ + "static/en-3-d2e1e9271a7456664439b0ffe3c28bfc.png";